export const RENEWALS_TABLE_QUERY_KEY = "renewalsTable";

export const DEFAULT_SCHOOL_YEAR = "24-25";
export const SCHOOL_YEAR_CHOICES = [
  { key: "24-25", text: "2024-2025" },
  { key: "23-24", text: "2023-2024" },
];
